import { transaction } from 'mobx';
import { getPrivateActionId } from './actionCreator';
import { getGlobalContext } from './globalContext';
export function subscribe(actionId, callback) {
    var subscriptions = getGlobalContext().subscriptions;
    if (!subscriptions[actionId]) {
        subscriptions[actionId] = [];
    }
    subscriptions[actionId].push(callback);
}
export function dispatch(actionMessage) {
    var currentMutator = getGlobalContext().currentMutator;
    if (currentMutator) {
        throw new Error("Mutator (" + currentMutator + ") may not dispatch action (" + actionMessage.type + ")");
    }
    var dispatchWithMiddleware = getGlobalContext().dispatchWithMiddleware || finalDispatch;
    transaction(dispatchWithMiddleware.bind(null, actionMessage));
}
export function finalDispatch(actionMessage) {
    var actionId = getPrivateActionId(actionMessage);
    var subscribers = getGlobalContext().subscriptions[actionId];
    if (subscribers) {
        var promises = [];
        for (var _i = 0, subscribers_1 = subscribers; _i < subscribers_1.length; _i++) {
            var subscriber = subscribers_1[_i];
            var returnValue = subscriber(actionMessage);
            if (returnValue) {
                promises.push(returnValue);
            }
        }
        if (promises.length) {
            return promises.length == 1 ? promises[0] : Promise.all(promises);
        }
    }
}
